import { useObserver } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components';

import { useStores } from '../../stores';
import { Caption } from './Caption';
import { CaptionClassic } from './CaptionClassic';
import ExtraHeader from './ExtraHeader';

const MobileControls = React.lazy(() => import('./MobileControls'));
const DesktopControls = React.lazy(() => import('./DesktopControls'));

const Header = () => {
  const { ui, chatWindow, config } = useStores();
  const { fontFamily, header, window: windowConfig } = config;
  const isAvatar = header.avatar.enabled;

  return useObserver(() => (
    <>
      {ui.isVisibleExtraHeader && isAvatar && <ExtraHeader />}
      <Root
        height={header.height}
        fontFamily={fontFamily}
        textColor={header.title.color}
        background={header.backgroundGradient ? header.backgroundGradient : header.background}
        borderColor={windowConfig.background}
        borderRadius={windowConfig.borderRadius}
        boxShadow={windowConfig.boxShadow}
        isFullScreen={chatWindow.isFullScreen}
        className={chatWindow.isFullScreen || chatWindow.isEmbedded ? '' : 'react-rnd-draggable'}
      >
        {header.classicView ? <CaptionClassic /> : <Caption />}
        {ui.isMobile ? <MobileControls /> : <DesktopControls />}
      </Root>
    </>
  ));
};

const Root = styled.div`
  position: static !important;
  z-index: auto !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: none;
  width: auto;
  min-width: auto;
  height: ${({ height }) => `${height}px`};
  min-height: auto;
  padding: 2px 20px !important;
  margin: 0;
  font-family: ${props => props.fontFamily};
  text-align: left;
  color: ${props => props.textColor};
  background: ${props => props.background};
  border: none;
  border-bottom: ${props => `1px solid ${props.borderColor}`};
  border-radius: ${({ isFullScreen, borderRadius }) =>
    isFullScreen ? 0 : `${borderRadius}px ${borderRadius}px 0 0`};
  box-shadow: ${props => props.boxShadow};
  overflow: visible;

  div {
    margin: 0;
  }
`;

export default Header;
